import { Injectable } from '@angular/core';
import {
  AlertController,
  LoadingController,
  ToastController,
} from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root',
})
export class LoaderService {
  public loading: HTMLIonLoadingElement | null = null;
  private loadingPromise: Promise<HTMLIonLoadingElement> | null = null;

  constructor(
    private alertCtrl: AlertController,
    private translateservice: TranslateService,
    private loadingController: LoadingController
  ) { }

  async showLoader(
    message: string = this.translateservice.instant('toast_please_wait')
  ) {
    if (this.loading || this.loadingPromise) {
      return;
    }

    this.loadingPromise = this.loadingController
      .create({
        message,
        spinner: 'crescent',
        backdropDismiss: false,
      })
      .then(async (loading) => {
        this.loading = loading;
        await loading.present();
        return loading;
      })
      .finally(() => {
        this.loadingPromise = null;
      });

    await this.loadingPromise;
  }

  /** Hide loading spinner #SH: Added */
  async hideLoader() {
    if (this.loadingPromise) {
      try {
        await this.loadingPromise;
      } catch (error) {
        console.warn('Loader creation failed before dismiss.', error);
      }
    }

    if (!this.loading) {
      return;
    }

    const loading = this.loading;
    this.loading = null;

    try {
      await loading.dismiss();
    } catch (error) {
      console.warn('Loader dismiss failed.', error);
    }
  }

  async showPopup(
    title: string,
    text: string,
    okText: string
  ): Promise<boolean> {
    return new Promise(async (resolve) => {
      const alert = await this.alertCtrl.create({
        header: title,
        message: text,
          mode:'md',
        backdropDismiss: false,
        buttons: [
          {
            text: okText,
            cssClass: 'button popup-btn',
            handler: () => {
              resolve(true); 
            },
          },
        ],
      });
      await alert.present();
    });
  }

  async showConfirmPopup(
    title: string,
    message: string,
    okText: string,
    cancelText: string
  ): Promise<boolean> {
    return new Promise(async (resolve) => {
      const alert = await this.alertCtrl.create({
        header: title,
        message: message,
          mode:'md',
        backdropDismiss:false,
        buttons: [
          {
            text: cancelText,
            role: 'cancel',
            cssClass: 'button popup-btn',
            handler: () => resolve(false),
          },
          {
            text: okText,
            cssClass: 'button popup-btn',
            handler: () => resolve(true),
          },
        ],
      });
      await alert.present();
    });
  }


}
